import { cookie } from "@/utils/cookie"

const ALLOWED_LANGUAGES = ["en", "de", "es", "pt"]

const LOCALE_COOKIE_KEY = "locale"
const DEFAULT_LANGUAGE = "en"

const ALLOWED_SEPARATORS_REGEX = /-|_/
const SEPARATOR_INDEX = 0
const LOCALE_INDEX = 0

function getAllowedLanguage(language) {
  if (!language) {
    return null
  }

  const separator = ALLOWED_SEPARATORS_REGEX.exec(language)

  const shortLanguage = separator ? language.split(separator[SEPARATOR_INDEX])[LOCALE_INDEX] : language

  if (ALLOWED_LANGUAGES.includes(shortLanguage.trim())) {
    return shortLanguage
  }

  return null
}

function getUserLocale() {
  const cookieLanguage = getAllowedLanguage(cookie(LOCALE_COOKIE_KEY))

  if (cookieLanguage) {
    return cookieLanguage
  }

  for (const locale of navigator.languages) {
    const language = getAllowedLanguage(locale)
    if (language) {
      cookie(LOCALE_COOKIE_KEY, language)
      return language
    }
  }

  cookie(LOCALE_COOKIE_KEY, DEFAULT_LANGUAGE)
  return DEFAULT_LANGUAGE
}

// Note: For vue components please prefer to get the locale from `this.$i18n.locale` and not via this helper.
export const getLocale = (path) => {
  if (path === undefined) {
    path = window.location.pathname
  }

  for (let language of ALLOWED_LANGUAGES) {
    const isSameAsPathLanguage = path === `/${language}` || path.indexOf(`/${language}/`) === 0

    if (isSameAsPathLanguage) {
      return language
    }
  }

  return getUserLocale()
}

export default getLocale

export const getLocaleBase = () => {
  const path = window.location.pathname
  const language = getLocale(path)

  if (path === `/${language}` || path.indexOf(`/${language}/`) === 0) {
    return `${language}/`
  }

  return ""
}
